import React, { useState } from 'react';

import type {
  GodtTeasers,
  Recommendations,
} from '../../../../types/frapi-types.js';
import type { OptionalDataFailed } from '../../../../../core/fetching/index.js';

import Teaser from '../../teasers/Teaser.js';
import { usePulseContext } from '../../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';
import { transformGodtToFrapi } from '../helpers.js';

interface RecommendedProps {
  recommendations: Recommendations;
  isMobile: boolean;
  godtTeasers?: GodtTeasers | OptionalDataFailed;
  isRestaurantSection?: boolean;
}

export const Recommended: React.FC<RecommendedProps> = ({
  recommendations,
  godtTeasers,
  isRestaurantSection,
  isMobile,
}) => {
  const [teaserCount, setTeaserCount] = useState(3);
  const { trackElementClick } = usePulseContext();

  const handleOnClick = () => {
    trackElementClick({
      object: {
        id: `recirculation:see-more-button`,
        name: 'See three more articles',
      },
    }).finally(() => setTeaserCount(teaserCount + 3));
  };

  let teasers;

  const hasGodtTeasers =
    godtTeasers && 'items' in godtTeasers && godtTeasers.items.length > 0;

  if (isRestaurantSection && hasGodtTeasers) {
    const formattedGodtTeasers = transformGodtToFrapi(godtTeasers);
    teasers = [
      ...recommendations.items.slice(0, 2),
      formattedGodtTeasers.items[0],
      ...recommendations.items.slice(2),
    ];
  } else {
    teasers = recommendations.items;
  }

  const hasMoreTeasers = teaserCount < teasers.length;

  return (
    <div className="recommended">
      <div className="recommended-wrapper">
        <h4>Fått med deg disse?</h4>
        <div className="articles-wrapper">
          {teasers.slice(0, teaserCount).map((r) => (
            <Teaser
              {...r}
              key={r.id}
              size={isMobile ? 'big' : 'small'}
              lazyLoad={true}
              fullWidthTeaser={false}
            />
          ))}
        </div>
      </div>

      {hasMoreTeasers && (
        <div className="see-more">
          <button onClick={handleOnClick}>
            <img
              src={`${frontendConfig.cdnUrlInternal}/vink/images/icons/plus.svg`}
              alt="Se flere artikler"
            />
            Se flere artikler
          </button>
        </div>
      )}
    </div>
  );
};
